import React, {Component} from 'react';
import './styles.css';
import CardHelper from "../../helpers";
import EpgPersistence from '../../../../AAF/Nepg/EpgPersistence';
import { Dates } from '../../../../packages/dates';
import ChannelSingleton from '../../../../components/Epg/ChannelsSingleton';
import Asset from '../../../../requests/apa/Asset';
import { NpvrUtil } from './../../../../AAF/Npvr/NpvrUtil';
import { NPVR_RECORDED_STATUS } from './../../../../AAF/Npvr/Constans';
import Utils from '../../../../utils/Utils';
import channelStreamUtil from '../../../../utils/ChannelStreamUtil';
import { getDay, getYear } from 'date-fns';

class CardRecording extends Component{
  constructor(props) {
    super(props);
    this.state = {
      showActions: false
    };
    this.isRecentActivity = props.isRecentActivity;
    this.hasPlayerIcon = true;
    this.cover = null;
    this.episodesIcon = Asset.get('content_data_option_button_seasons');
    this.bookmark = props.bookmark;
    this.title = props.data.isEpisode ? Utils.cutInTwoLines(props.data.description, 18) : props.title;
    this.showFooter = props.showFooter;
    this.onDeleteAction = props.onDeleteAction;
    this.data = props.data;
    this.badges = props.badges;
    this.time = this.data.duration;
    this.numEpisodios = (props.data && props.data.numEpisodes) ? props.data.numEpisodes : false;
    this.limit = this.data.limit || ChannelSingleton.getNpvrStorage(this.data.group_id);
    this.hour = parseInt(this.time/(60*60));
    this.minute = parseInt((this.time-(this.hour*60*60))/60);
    const statusInt = this.data.status ? NpvrUtil.parseStringStatusToInt(this.data.status) : NPVR_RECORDED_STATUS;
    const statusData = NpvrUtil.getRecordingAsset(statusInt);
    this.statusLabel = statusData && statusData.label ? <span className='statusLabel'>{statusData.label}</span> : <span className='statusLabel'>RecordingsUtil.getRecordStatusLabel(this.data.status)</span>;
    this.statusIcon = statusData && statusData.imageSrc ? (<img className='statusIcon' src={statusData.imageSrc}/>) : <i className="fa fa-television status-icon-recording" aria-hidden="true"></i>;
    this.pgress = 0;
    this.id = props.id;
    this.date = '';

    if(props.cover){
      this.cover = props.cover;
    }
    else {
      const gidData = channelStreamUtil.get(this.data.group_id);
      if(gidData && gidData.cover) {
        let gidCover = gidData.cover;
        gidCover = gidCover.replace('size=290x163', 'size=168x96'); 
        this.cover = gidCover;
      }
    }

    if(!this.cover) {
      this.cover = Asset.get('asset_placeholder_landscape','/images/placeholder_landscape.png');
    }

    if(this.data.dateOfRecord){
      const dateOfRecord = EpgPersistence.needsOffset()
        ? new Dates(this.data.dateOfRecord, 'YYYY-MM-DDThh:mm:ssZ')
          .utcOffset(EpgPersistence.needsOffset(), false)
          .format("dddd DD/MM/YYYY 'a las' HH:mm'hs.'")
        : new Dates(this.data.dateOfRecord, 'YYYY-MM-DDThh:mm:ssZ').format(
          "dddd DD/MM/YYYY 'a las' HH:mm'hs.'"
        ); //Se sustituye por dateOfEvent
      this.date = dateOfRecord.split(' ')[1];
    }
  }

  componentWillUpdate(nextProps){
    if(nextProps.showActions !== this.state.showActions){
      document.dispatchEvent(
        new CustomEvent('update_recording_progress_bar', {
          detail: { time_used: this.data.used, time_limit: this.limit, packId: this.data && this.data.packId }
        })
      );
      this.setState({showActions: nextProps.showActions});
    }
  }

  render() {
    const descriptionRecord = this.time && this.date && `${this.hour} hr ${this.minute} min ${formatDate(this.date)}`;
    const descriptionSeries = Utils.numberEpisodesCardRecordings(this.numEpisodios || 0);
    const description = this.data.isSeries ? descriptionSeries : descriptionRecord;
    const episodesIconImg = this.data.isSeries ? (
      <img className='episodeIcon' src={this.episodesIcon}/>
    ) : null;
    return (
      <div className={'card card-recordings'}>
        <div className={'card-container'}>
          {this.cover !== '' &&
          <div
            className='card-cover'
            style={{backgroundImage: `url(${this.cover})`}}
          />
          }
          {CardHelper.createProgressBar(this.pgress, this.hasPlayerIcon)}
          {CardHelper.createBadge(this.badges)}
          {CardHelper.createPlayerIcon()}
        </div>
        <div className={'card-info'}>
          <div className={'card-info_container'}>
            <p className={'title'}>{this.title}</p>
            <p className={'description'}>{episodesIconImg}<span className='descriptionText' id={`serie_${this.props.data && this.props.data.ext_series_id  ? this.props.data.ext_series_id : ''}`}> {`${description}`}</span></p>
            <p className={'status'}>
              {this.data && this.data.status ? this.statusIcon : <span>{''}</span>}{this.data && this.data.status ? this.statusLabel :  <span>{''}</span>}{this.state.showActions && this.isRecentActivity && CardHelper.createDeleteIcon()}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default CardRecording;

function formatDate(date) {
  let [day, month, year] = date.split("/");
  let months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
  return `${months[Number(month - 1)]} ${day}, ${year}`;
}


// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardRecording/index.js